import React from 'react';

export const SharepointPresentationIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip5_8166_29849)">
			<path
				d="M5.5 15H14.5C14.77 15 15 14.775 15 14.5V5H13.5C12.67 5 12 4.327 12 3.5V1H5.5C5.22 1 5 1.225 5 1.5V14.5C5 14.775 5.22 15 5.5 15Z"
				fill="white"
			/>
			<path
				d="M15 4V3.914C15 3.848 14.99 3.783 14.96 3.723C14.94 3.662 14.9 3.607 14.85 3.561L13 1.707V3.5C13 3.775 13.22 4 13.5 4H15Z"
				fill="white"
			/>
			<path
				opacity="0.64"
				d="M15.56 2.853L13.15 0.44C12.86 0.16 12.48 0.001 12.09 0H5.5C4.67 0 4 0.673 4 1.5V14.5C4 15.327 4.67 16 5.5 16H14.5C15.33 16 16 15.327 16 14.5V3.914C16 3.514 15.84 3.137 15.56 2.854V2.853ZM14.85 3.561C14.95 3.655 15 3.781 15 3.914V4H13.5C13.37 4 13.24 3.947 13.15 3.853C13.05 3.76 13 3.633 13 3.5V1.707L14.85 3.561H14.85ZM14.5 15H5.5C5.37 15 5.24 14.947 5.15 14.853C5.05 14.76 5 14.633 5 14.5V1.5C5 1.225 5.23 1 5.5 1H12V3.5C12 4.327 12.67 5 13.5 5H15V14.5C15 14.775 14.77 15 14.5 15Z"
				fill="#605E5C"
			/>
			<path
				d="M12.95 9H11L10.5 8L10 9V11.95C10.4 12.033 10.82 12.014 11.22 11.895C11.62 11.776 11.98 11.561 12.27 11.268C12.56 10.976 12.78 10.616 12.89 10.22C13.01 9.824 13.03 9.405 12.95 9Z"
				fill="#ED6C47"
			/>
			<path
				d="M10.5 7C10.33 7 10.16 7.021 10 7.055V9H11V7.05C10.84 7.017 10.67 7 10.5 7Z"
				fill="#FF8F6B"
			/>
			<path
				d="M12 8H14C13.9 7.507 13.66 7.055 13.3 6.7C12.94 6.344 12.49 6.101 12 6V8Z"
				fill="#FFC7B5"
			/>
			<path
				d="M1 13H8C8.27 13 8.52 12.895 8.71 12.707C8.89 12.52 9 12.265 9 12V5C9 4.735 8.89 4.48 8.71 4.293C8.52 4.105 8.27 4 8 4H1C0.73 4 0.48 4.105 0.29 4.293C0.11 4.48 0 4.735 0 5V12C0 12.265 0.11 12.52 0.29 12.707C0.48 12.895 0.73 13 1 13Z"
				fill="#C43E1C"
			/>
			<path d="M4 6H5V7H4V6ZM4 8H5V9H4V8Z" fill="white" />
			<path d="M3.5 11V6" stroke="white" strokeMiterlimit="10" />
			<path
				d="M4.5 6.5H5C5.38 6.5 5.62 6.778 5.62 7.33C5.62 7.87 5.6 8.5 5.12 8.5H4.5"
				stroke="white"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="bevel"
			/>
			<path fillRule="evenodd" clipRule="evenodd" d="M5 7H5.16V8H5V7Z" fill="white" />
		</g>
	</svg>
);
